import MaxRegisterModal from '@/components//MaxRegisterModal/v2';
import PromoMaxRegModal from './components/promo-max-register-modal/PromoMaxRegModal';
import MaxRegisterModal2 from './components/max-register-modal/MaxRegisterModal';
import ChooseTypeRegister from './components/choose-type-register/ChooseTypeRegister';
import ManualRegister from './components/manual-register/ManualRegister';

export default {
  name: 'Regist',
  components: {
    MaxRegisterModal,
    PromoMaxRegModal,
    MaxRegisterModal2,
    ChooseTypeRegister,
    ManualRegister
  },
  data() {
    return {
      registStepPage: 1, // 当前注册步骤的流程，1为显示注册的第1页。
      commitLoading: false,
      bindPhoneModalShow: true,
      maxWalletModalShow: false,
      maxWalletLogo: require('@/assets/images/account/max-wallet.png'),
      maxWalletPkgType: 'REGISTER',
      showRegisterForm: true,
      showRegister: false,
      upgradeModalShow: false,
      upgradeModalShow2: false,
      downloadModalShow: false,
      chooseTypeRegisterShow: true,
      imgStep1: require('@/assets/images/account/max-register-step-1.png'),
      imgStep2: require('@/assets/images/account/max-register-step-2.png'),
      imgStep3: require('@/assets/images/account/max-register-step-3.png'),
      walletBg: require('@/assets/images/home/max-wallet.png'),
      btnList: {
        max_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        max_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' }
      },
      refCode: ''
    };
  },
  mounted() {
    let inviteCode = this.$route.query.inviteCode;
    if (inviteCode) {
      this.refCode = inviteCode;
    }
  },
  methods: {
    showMaxRegisterModal() {
      this.maxWalletModalShow = true;
      this.chooseTypeRegisterShow = false;
    },
    showUpgradeModal() {
      this.upgradeModalShow = true;
      this.chooseTypeRegisterShow = false;
    },
    showMaxRegister() {
      this.upgradeModalShow = false;
      this.$nextTick(() => {
        this.maxWalletModalShow = true;
      });
    },
    showRegisterModal() {
      this.showRegisterForm = true;
      this.showRegister = true;
      this.$nextTick(() => {
        this.chooseTypeRegisterShow = false;
        this.maxWalletModalShow = false;
      });
    },
    showChooseTypeRegisterModal() {
      this.showRegisterForm = false;
      this.showRegister = false;
      this.$nextTick(() => {
        this.chooseTypeRegisterShow = true;
        this.maxWalletModalShow = false;
      });
    },
    showDownloadModal() {
      this.downloadModalShow = true;
    },
    redirectToHome() {
      this.$router.push({ name: 'home' });
    }
  }
};
